import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ContentService } from '../../services/status-tracker/content.service';
import {
  loadAEMSummaryContent,
  loadAEMSummaryContentFailure,
  loadAEMSummaryContentSuccess
} from '../actions/status-tracker.actions';

@Injectable()
export class SummaryContentEffects {
  loadSummaryContent$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadAEMSummaryContent),
      switchMap(() =>
        this.content.getSummaryContent().pipe(
          map((content) => {
            return loadAEMSummaryContentSuccess({
              aemStatusTrackerSummaryContent: {
                id: 'aem-summary-content',
                aemSummaryContent: content
              }
            });
          }),
          catchError(() =>
            of(
              loadAEMSummaryContentFailure({
                error: {
                  id: 'aem-summary-content-error',
                  aemSummaryContentError: 'full-page'
                }
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly content: ContentService
  ) {}
}
